<template>
  <div class="row mb-3">
    <div class="col-md-6">
      <el-form
        :inline="false"
        :rules="rules"
        :size="'small'"
        class="contact-form-inline"
        :label-position="'left'"
        :model="contact"
        v-if="loading == false"
      >
        <el-row
          v-for="colGroup in getContactFields[0]"
          style="margin-bottom: 4px"
          :gutter="4"
        >
          <el-col
            v-for="col in colGroup"
            :span="24 / colGroup.length"
            :xs="24 / colGroup.length"
            :sm="24 / colGroup.length"
            :md="(12 / colGroup.length) * 2"
            :lg="(12 / colGroup.length) * 2"
            :xl="(12 / colGroup.length) * 2"
          >
            <v-text-field
              v-if="col.attribute == 'first_name'"
              type="text"
              label="First Name"
              v-model="contact.first_name"
              @change="patchContact('first_name')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'last_name'"
              type="text"
              label="Last Name"
              v-model="contact.last_name"
              @change="patchContact('last_name')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'company_name'"
              type="text"
              label="Company Name"
              v-model="contact.company_name"
              @change="patchContact('company_name')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <!-- Email deviates from standard edit as we want to include refuse to give -->
            <VuetifyEmailConfirmInput
              v-if="col.attribute == 'email'"
              label="Email"
              v-model="contact.email"
              @change="patchContact('email')"
              :refused-email="!!contact.refused_email_at"
              @update:refused-email="contact.refused_email_at = $event ? new Date().toISOString() : null; patchContact('refused_email_at');"
              :require-email="requireEmail"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <VuetifyPhoneInput
              v-if="col.attribute == 'mobile_phone'"
              :initial="contact.mobile_phone"
              :label="'Mobile Phone'"
              @update:phone="contact.mobile_phone = $event"
              @change="patchContact('mobile_phone')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <VuetifyPhoneInput
              v-if="col.attribute == 'home_phone'"
              :initial="contact.home_phone"
              :label="'Home Phone'"
              @update:phone="contact.home_phone = $event"
              @change="patchContact('home_phone')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'address_1'"
              label="Address Line 1"
              type="text"
              v-model="contact.address_1"
              @change="patchContact('address_1')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'address_2'"
              label="Address Line 2"
              type="text"
              v-model="contact.address_2"
              @change="patchContact('address_2')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'locality'"
              label="Locality / City"
              type="text"
              v-model="contact.locality"
              @change="patchContact('locality')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'region'"
              label="Region / State"
              type="text"
              v-model="contact.region"
              @change="patchContact('region')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-text-field
              v-if="col.attribute == 'postal'"
              label="Postal Code"
              v-model="contact.postal"
              @change="patchContact('postal')"
              density="compact"
              autocomplete="off"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <VuetifyDatePicker
              v-if="col.attribute == 'birthday'"
              v-model="contact.birthday"
              label="Birthday"
              placeholder="Birthday"
              format="M-DD-YYYY"
              @change="patchContact('birthday')"
              :disabled="contact.is_locked"
            />
            <VuetifyDatePicker
              v-if="col.attribute == 'anniversary'"
              v-model="contact.anniversary"
              label="Anniversary"
              placeholder="Anniversary"
              format="M-DD-YYYY"
              @change="patchContact('anniversary')"
              :disabled="contact.is_locked"
            />
            <v-checkbox
              v-if="col.attribute == 'is_vip'"
              v-model="contact.is_vip"
              label="VIP"
              @change="patchContact('is_vip')"
              density="compact"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <v-checkbox
              v-if="col.attribute == 'do_not_rent'"
              v-model="contact.do_not_rent"
              label="Do Not Rent"
              @change="patchContact('do_not_rent')"
              density="compact"
              hide-details="auto"
              :disabled="contact.is_locked"
            />
            <!-- exhaustive ifs so it defaults to just input on unexpected tyeps -->
            <template v-if="col.attribute.startsWith('custom_fields')">
              <v-text-field
                v-if="col.data_type == 'string'"
                :label="col.label"
                v-model="contact.custom_fields[col.field_name]"
                @update:model-value="patchContact('custom_fields')"
                autocomplete="off"
                density="compact"
                :disabled="contact.is_locked"
              />

              <v-select
                v-else-if="col.data_type == 'select'"
                v-model="contact.custom_fields[col.field_name]"
                :label="col.label"
                @update:model-value="patchContact('custom_fields')"
                :items="
                  (col.values || []).map((v) => {
                    return { value: v.value, title: v.label };
                  })
                "
                autocomplete="off"
                :disabled="contact.is_locked"
                variant="outlined"
                density="compact"
              />

              <VuetifyDatePicker
                v-else-if="col.data_type == 'date'"
                :label="col.label"
                density="compact"
                :model-value="dateOnlyValue(col)"
                @update:model-value="setCustomFieldDate(col, $event)"
                :disabled="contact.is_locked"
              />

              <VuetifyDateTimePicker
                v-else-if="col.data_type == 'datetime'"
                :label="col.label"
                density="compact"
                format="M-DD-YYYY hh:mm A"
                :model-value="contact.custom_fields[col.field_name]"
                @update:model-value="setCustomFieldDateTime(col, $event)"
                placeholder="Select date and time"
                autocomplete="off"
                :disabled="contact.is_locked"
              />

              <v-textarea
                v-else-if="col.data_type == 'text'"
                :label="col.label"
                v-model="contact.custom_fields[col.field_name]"
                @update:model-value="patchContact('custom_fields')"
                autocomplete="off"
                density="compact"
                rows="3"
                auto-grow
                hide-details="auto"
                :disabled="contact.is_locked"
              />

              <VuetifyNumberInput
                v-else-if="col.data_type == 'number'"
                :label="col.label"
                v-model="contact.custom_fields[col.field_name]"
                @update:model-value="patchContact('custom_fields')"
                autocomplete="off"
                density="compact"
                :disabled="contact.is_locked"
              />

              <v-text-field
                v-else
                :label="col.label"
                v-model="contact.custom_fields[col.field_name]"
                @update:model-value="patchContact('custom_fields')"
                autocomplete="off"
                density="compact"
                :disabled="contact.is_locked"
              />
            </template>
          </el-col>
        </el-row>
        <el-tabs
          v-if="getProfiles?.length"
          v-model="selectedProfile"
          @tab-click="changeProfile"
          class="custom-field-profiles"
        >
          <el-tab-pane v-for="p of getProfiles" :label="p.label" :name="p.id">
            <template #label>
              <span>
                {{ p.label }}
                <font-awesome-icon
                  v-if="getUsedProfiles.includes(p.id)"
                  :icon="['fas', 'octagon-check']"
                />
              </span>
            </template>
            <el-row
              v-for="colGroup in getContactFields[selectedProfile]"
              style="margin-bottom: 4px"
              :gutter="4"
            >
              <el-col
                v-for="col in colGroup"
                :span="24 / colGroup.length"
                :xs="24 / colGroup.length"
                :sm="24 / colGroup.length"
                :md="(12 / colGroup.length) * 2"
                :lg="(12 / colGroup.length) * 2"
                :xl="(12 / colGroup.length) * 2"
              >
                <v-text-field
                  v-if="col.attribute == 'first_name'"
                  type="text"
                  label="First Name"
                  v-model="contact.first_name"
                  @change="patchContact('last_name')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-text-field
                  v-if="col.attribute == 'last_name'"
                  type="text"
                  label="Last Name"
                  v-model="contact.last_name"
                  @change="patchContact('last_name')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'company_name'"
                  type="text"
                  label="Company Name"
                  v-model="contact.company_name"
                  @change="patchContact('company_name')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-text-field
                  v-if="col.attribute == 'email'"
                  type="email"
                  label="Email"
                  placeholder="Enter a email address"
                  v-model="contact.email"
                  @change="patchContact('email')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <VuetifyPhoneInput
                  v-if="col.attribute == 'mobile_phone'"
                  :initial="contact.mobile_phone"
                  :label="'Mobile Phone'"
                  @update:phone="contact.mobile_phone = $event"
                  @change="patchContact('mobile_phone')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <VuetifyPhoneInput
                  v-if="col.attribute == 'home_phone'"
                  :initial="contact.home_phone"
                  :label="'Home Phone'"
                  @update:phone="contact.home_phone = $event"
                  @change="patchContact('home_phone')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-text-field
                  v-if="col.attribute == 'address_1'"
                  label="Address Line 1"
                  type="text"
                  v-model="contact.address_1"
                  @change="patchContact('address_1')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'address_2'"
                  label="Address Line 2"
                  type="text"
                  v-model="contact.address_2"
                  @change="patchContact('address_2')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'locality'"
                  label="Locality / City"
                  type="text"
                  v-model="contact.locality"
                  @change="patchContact('locality')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'region'"
                  label="Region / State"
                  type="text"
                  v-model="contact.region"
                  @change="patchContact('region')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />

                <v-text-field
                  v-if="col.attribute == 'postal'"
                  label="Postal Code"
                  v-model="contact.postal"
                  @change="patchContact('postal')"
                  density="compact"
                  autocomplete="off"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-select
                  v-if="col.attribute == 'country'"
                  label="Country Code"
                  v-model="contact.country"
                  @update:model-value="patchContact('country')"
                  :items="
                    isoCountries.map((c) => ({
                      value: c.Code,
                      title: c.Name,
                    }))
                  "
                  variant="outlined"
                  density="compact"
                  :disabled="contact.is_locked"
                  hide-details="auto"
                  clearable
                />

                <VuetifyDatePicker
                  v-if="col.attribute == 'birthday'"
                  label="Birthday"
                  format="MM-DD-YYYY"
                  v-model="contact.birthday"
                  @update:model-value="patchContact('birthday')"
                  variant="outlined"
                  density="compact"
                  autocomplete="off"
                  :disabled="contact.is_locked"
                  hide-details="auto"
                  clearable
                />

                <VuetifyDatePicker
                  v-if="col.attribute == 'anniversary'"
                  label="Anniversary"
                  format="MM-DD-YYYY"
                  v-model="contact.anniversary"
                  @update:model-value="patchContact('anniversary')"
                  variant="outlined"
                  density="compact"
                  autocomplete="off"
                  :disabled="contact.is_locked"
                  hide-details="auto"
                  clearable
                />
                <v-checkbox
                  v-if="col.attribute == 'is_vip'"
                  v-model="contact.is_vip"
                  label="VIP"
                  @change="patchContact('is_vip')"
                  density="compact"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <v-checkbox
                  v-if="col.attribute == 'do_not_rent'"
                  v-model="contact.do_not_rent"
                  label="Do Not Rent"
                  @change="patchContact('do_not_rent')"
                  density="compact"
                  hide-details="auto"
                  :disabled="contact.is_locked"
                />
                <!-- Same set of inputs as the layout above -->
                <template v-if="col.attribute.startsWith('custom_fields')">
                  <v-text-field
                    v-if="col.data_type == 'string'"
                    :label="col.label"
                    v-model="contact.custom_fields[col.field_name]"
                    @update:model-value="patchContact('custom_fields')"
                    autocomplete="off"
                    density="compact"
                    :disabled="contact.is_locked"
                  />

                  <v-select
                    v-else-if="col.data_type == 'select'"
                    v-model="contact.custom_fields[col.field_name]"
                    :label="col.label"
                    @update:model-value="patchContact('custom_fields')"
                    :items="
                      (col.values || []).map((v) => {
                        return { value: v.value, title: v.label };
                      })
                    "
                    autocomplete="off"
                    :disabled="contact.is_locked"
                    variant="outlined"
                    density="compact"
                  />

                  <!-- Picked, never typed, so what is stored stays parseable -->
                  <VuetifyDatePicker
                    v-else-if="col.data_type == 'date'"
                    :label="col.label"
                    density="compact"
                    :model-value="dateOnlyValue(col)"
                    @update:model-value="setCustomFieldDate(col, $event)"
                    :disabled="contact.is_locked"
                  />

                  <VuetifyDateTimePicker
                    v-else-if="col.data_type == 'datetime'"
                    :label="col.label"
                    density="compact"
                    format="M-DD-YYYY hh:mm A"
                    :model-value="contact.custom_fields[col.field_name]"
                    @update:model-value="setCustomFieldDateTime(col, $event)"
                    placeholder="Select date and time"
                    autocomplete="off"
                    :disabled="contact.is_locked"
                  />

                  <v-textarea
                    v-else-if="col.data_type == 'text'"
                    :label="col.label"
                    v-model="contact.custom_fields[col.field_name]"
                    @update:model-value="patchContact('custom_fields')"
                    autocomplete="off"
                    density="compact"
                    rows="3"
                    auto-grow
                    hide-details="auto"
                    :disabled="contact.is_locked"
                  />

                  <VuetifyNumberInput
                    v-else-if="col.data_type == 'number'"
                    :label="col.label"
                    v-model="contact.custom_fields[col.field_name]"
                    @update:model-value="patchContact('custom_fields')"
                    autocomplete="off"
                    density="compact"
                    :disabled="contact.is_locked"
                  />

                  <v-text-field
                    v-else
                    :label="col.label"
                    v-model="contact.custom_fields[col.field_name]"
                    @update:model-value="patchContact('custom_fields')"
                    autocomplete="off"
                    density="compact"
                    :disabled="contact.is_locked"
                  />
                </template>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { nestFormFields } from 'src/util/formFields';

import VuetifyDatePicker from 'src/components/UIComponents/Inputs/VuetifyDatePicker.vue';
import VuetifyDateTimePicker from 'src/components/UIComponents/Inputs/VuetifyDateTimePicker.vue';
import VuetifyCurrencyInput from 'src/components/UIComponents/Inputs/VuetifyCurrencyInput.vue';
import VuetifyNumberInput from 'src/components/UIComponents/Inputs/VuetifyNumberInput.vue';
import VuetifyPhoneInput from 'src/components/UIComponents/Inputs/VuetifyPhoneInput.vue';
import VuetifyEmailConfirmInput from 'src/components/UIComponents/Inputs/VuetifyEmailConfirmInput.vue';

import contactServices from 'src/services/contactServices';
import { toDateOnlyString, toPickerDate } from 'src/util/plainDate';
import PhoneNumber from 'src/components/UIComponents/Inputs/PhoneNumber';
import { processError } from 'src/util/processError.js';

export default {
  components: {
    PhoneNumber,
    // Vuetify
    VuetifyDatePicker,
    VuetifyCurrencyInput,
    VuetifyDateTimePicker,
    VuetifyNumberInput,
    VuetifyPhoneInput,
    VuetifyEmailConfirmInput,
  },
  props: {
    contactId: {
      type: Number,
      required: true,
    },
    requireEmail: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    getContactTypes() {
      return this.contactTypes;
    },
    rules() {
      const rules = {
        // Add in any required fields here
      };
      for (const c of this.getCustomFields) {
        if (c.is_required) {
          rules['custom_fields.' + c.field_name] = [
            { required: true, trigger: 'change' },
          ];
        }
      }
      return rules;
    },
    ...mapGetters('appConfig', ['getAppConfig']),
    // ...mapGetters('contactType', ['getContactTypes']),
    ...mapGetters('customFields', ['getContactCustomFields']),
    ...mapGetters('formFieldProfiles', ['getFormFieldProfiles']),
    getUsedProfiles() {
      // Mostly efficient single pass to get used profiles.
      // Short circuits and checks at most N sub sets one for each profile
      // and returns as soon as first result is matched. Should be faster than
      // walking all the fields one time.
      if (!this.getContactFields || this.contact?.custom_fields?.length < 1) {
        return [];
      }

      const usedFields = Object.keys(this.contact.custom_fields);
      const used = this.getProfiles
        .map((p) => {
          if (!this.getContactFields[p.id]) {
            return undefined;
          }
          for (const [dOrd, vals] of Object.entries(
            this.getContactFields[p.id]
          )) {
            const found = vals.find((c) =>
              usedFields.includes(c.field_name)
            )?.profile_id;
            if (found) {
              return found.profile_id;
            }
            // Check next display order otherwise
          }
          return undefined;
        })
        .filter((u) => u != undefined);
      return used;
    },
    getProfiles() {
      // For now we just list all contact profiles.
      // Not sure we want to limit this to a specific contac type yet
      return this.getFormFieldProfiles
        .filter((p) => p.object_type == 'contact')
        .sort((a, b) =>
          a.display_order > b.display_order
            ? 1
            : b.display_order > a.display_order
            ? -1
            : 0
        );

      if (!this.getContactTypes || !this.contact?.contact_type_id) {
        return [];
      }
      const profileIds = this.getContactTypes
        .find((ct) => ct.id == this.contact.contact_type_id)
        .contactTypeProfiles.map((p) => p.profile_id);
      return this.getFormFieldProfiles.filter((p) => profileIds.includes(p.id));
    },
    getCustomFields() {
      const customFields = [];
      // should make the component load dependant on this being set.
      // ie v-if getContactTypes.... is not undefined
      /*
       SKIP contact types as its dumb
       if (!this.getContactTypes) {
         return custom_fields;
       }
       const contactType = this.getContactTypes.find(ct => ct.id == this.contact.contact_type_id);
       // This will happen on first load before contact type is selected
       if (!contactType) {
         return custom_fields;
       }
       const profileIds = contactType.contactTypeProfiles.map(p => p.profile_id);
       */
      // Just all profiles for now
      const profileIds = this.getProfiles.map((p) => p.id);

      this.getContactCustomFields.map((cf) => {
        if (cf.profile_id == null || profileIds.includes(cf.profile_id)) {
          customFields.push({
            ...cf, // augment custom fields with needed column attributes
            display_order: cf.display_order ?? 10,
            attribute: 'custom_fields.' + cf.field_name,
            label: cf.label,
          });
        }
      });
      return customFields;
    },
    getContactFields() {
      // Nest objects ordered by profile_id -> display_order
      return nestFormFields(
        this.getAppConfig?.contact?.contactFormFields,
        this.getCustomFields
      );
    },
  },
  data() {
    return {
      loading: false,
      selectedProfile: undefined,
      valid: false,
      dirty: true,
      canPatch: false,

      contact: {
        id: null,
        first_name: '',
        last_name: '',
        address_1: '',
        address_2: '',
        locality: '',
        region: '',
        postal: '',
        country: 'US',
        home_phone: undefined,
        mobile_phone: undefined,
        email: undefined,
        refused_email_at: undefined,
        locale: 'en',
        timezone: '',
        company_name: undefined,

        unsubscribe_token: '',

        // Validation
        email_validated: undefined,
        email_validation_error: undefined,

        last_open_email: undefined,
        last_open_sms: undefined,
        last_sent_email: undefined,
        last_sent_sms: undefined,

        is_locked: false,
        is_vip: false,
        do_not_rent: false,
      },

      contactTypes: [
        {
          id: 1,
          name: 'Guest',
          is_default: true,
          contactTypeProfiles: [
            {
              id: 1,
              contact_type_id: 1,
              profile_id: 1,
              dislay_order: 1,
              is_default: true,
            },
            {
              id: 2,
              contact_type_id: 1,
              profile_id: 2,
              dislay_order: 2,
              is_default: false,
            },
          ],
        },
      ],
    };
  },
  watch: {
    contactId(n) {
      if (n) {
        this.loadContact();
      }
    },
    // The call type can change after the contact is loaded
    requireEmail() {
      if (this.loading || this.dirty) {
        return;
      }
      this.valid = this.emailValid();
      this.$emit('update:valid', this.valid);
    },
  },

  async created() {
    await this.loadContact();
  },
  methods: {
    ...mapActions('contacts', ['deleteContactCache']),
    // An email or refused to give is needed when required
    emailValid() {
      return (
        !this.requireEmail ||
        !!this.contact.email ||
        !!this.contact.refused_email_at
      );
    },
    changeProfile(profileId) {
      // anything we need
    },

    /**
     * values are always a string to/from API so we convert internallt to the
     * data type as needed. Eventually compontize this into a custom-field component
     */
    setCustomField(col, value) {
      if (this.contact.is_locked) {
        return;
      }
      this.contact.custom_fields[col.field_name] = value;
      this.patchContact('custom_fields');
    },

    dateOnlyValue(col) {
      // Use Temporal to get date only values from strings without zone shift
      // Eventual no polyfill but for now it needs it.
      return toPickerDate(this.contact.custom_fields[col.field_name]);
    },

    setCustomFieldDate(col, value) {
      // Again use temporal to set date only fields with no zone shift. Using polyfill
      this.setCustomField(col, toDateOnlyString(value));
    },

    setCustomFieldDateTime(col, value) {
      if (typeof value == 'string' && value.length) {
        this.setCustomField(col, value);
        return;
      }
      const picked = this.pickedDate(value);
      this.setCustomField(col, picked ? picked.toISOString() : null);
    },

    // Some are strings some are objects
    pickedDate(value) {
      if (!value) {
        return undefined;
      }
      const picked = value instanceof Date ? value : new Date(value);
      return isNaN(picked.getTime()) ? undefined : picked;
    },

    async loadContact() {
      this.loading = true;
      this.selectedProfile = this.getProfiles
        ? this.getProfiles.find((p) => p.is_default)?.id
        : undefined;

      const contactData = await contactServices.fetchContactById(
        this.contactId
      );
      // Update the primary email
      contactData.data.email = contactData.data.primaryEmail
        ? contactData.data.primaryEmail.email_address
        : undefined;
      contactData.data.refused_email_at = contactData.data.refused_email_at
        ? true
        : false;
      contactData.data.is_vip = !!contactData.data.is_vip;
      contactData.data.do_not_rent = !!contactData.data.do_not_rent;

      if (!contactData.data.custom_fields) {
        contactData.data.custom_fields = {};
      }
      this.contact = contactData.data;

      // TODO: Just for testing until loaded
      this.contact.contact_type_id = 1;

      this.dirty = false;
      this.valid = true;

      this.valid = this.emailValid();

      this.$emit('update:dirty', this.dirty);
      this.$emit('update:valid', this.valid);
      this.loading = false;
    },
    async patchContact(field) {
      if (this.contact.is_locked) {
        console.log('contact is locked');
        return;
      }

      this.valid = false;
      this.dirty = true;
      this.$emit('update:valid', this.valid);
      this.$emit('update:dirty', this.dirty);

      // Nulls need to unset properly
      if (this.contact[field] === '') {
        this.contact[field] = null;
      }

      // Cant patch until all required fields are entered.
      // Mostly around required custom fields as flat fields are fine
      // TODO: get this from the required fields rules and only save then
      const patch = {};

      // If patching custom fields it has to be a full set
      if (field.startsWith('custom_fields')) {
        // We drop all empty strings to unset the data points
        // TODO: need validate the data is what we want and required bits too
        patch.custom_fields = {};
        Object.keys(this.contact.custom_fields).forEach((k) => {
          if (this.contact.custom_fields[k] != '') {
            patch.custom_fields[k] = this.contact.custom_fields[k];
          }
        });
      } else if (field == 'refused_email_at') {
        // Unset if unchecked
        patch[field] = this.contact[field] ? new Date() : null;
      }
      // TODO: This will need to be reworked to support more than one email
      // Patch email
      else if (field == 'email') {
        patch.primary_email = this.contact[field];
        delete patch.email;
        patch.refused_email_at = null;
      } else {
        // ALl other fields are flat patches
        if (field == 'birthday' || field == 'anniversary') {
          patch[field] = this.contact[field]?.toISOString();
        }
        if (this.contact[field] === '') {
          this.contact[field] = null;
        }
        patch[field] = this.contact[field];
        // TODO: This will need to be reworked to support more than one email
        // Patch email
        if (patch.email) {
          patch.primary_email = patch.email;
          delete patch.email;
        }
      }

      if (patch == {}) {
        console.log('skipping empty patch');
        return false;
        // We will be stuck in an invalid/dirty as we dont unset anything
      }

      try {
        await contactServices.patchContact(this.contactId, patch);
        this.deleteContactCache(+this.id);
        this.valid = true;
        this.dirty = false;

        // Valid is also checked by the API when completing the call
        this.valid = this.emailValid();

        this.$emit('update:valid', this.valid);
        this.$emit('update:dirty', this.dirty);
      } catch (e) {
        // TODO: revert the fields on error otherwise they are out of sync
        this.$message({
          type: 'error',
          message: 'Error updating contact: ' + processError(e.response ?? e),
        });
      }
    },
  },
};
</script>
<style>
.checkbox-container {
  display: flex;
  align-items: center;
  padding-right: 8px;
}

.error-message {
  color: white;
  font-size: 12px;
  background-color: #f56c6c;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 4px;
  display: block;
}
</style>
